<template>
  <div class="rule">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="point:mall:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >创建商品</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #productType="{ row }">{{ row.productType }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #picture="{ row }">
        <img v-if="row.picture" class="image" :src="row.picture" alt="" srcset="">
        <span v-else>---</span>
      </template>
      <template #quantity="{ row }">{{ row.quantity }}</template>
      <template #remainingQuantity="{ row }">{{ row.remainingQuantity }}</template>
      <template #point="{ row }">{{ row.point +'积分'}}{{ row.amount > 0 ? '+'+row.amount+'元': '' }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #salesTime="{ row }">{{ row.salesTime ? row.salesTime : '---' }}</template>
      <template #effective="{ row }">{{ row.effective == 0 ? '下架' : '上架' }}</template>
      <template #soldOut="{ row }">{{ row.soldOut == 0 ? '未售罄' : '已售罄' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="exportMemberByPortrait(scope.row)" >导出会员</el-button > -->
        <auth-button auth="point:mall:read">
          <el-button type="text" class="mr10" @click="edit(scope.row)">查看详情</el-button>
        </auth-button>
        <auth-button v-if="scope.row.effective == 0 && !scope.row.overdue" auth="point:mall:update">
          <el-button type="text" class="error" @click="updateStatus(scope.row, 1)">上架</el-button>
        </auth-button>
        <auth-button v-if="scope.row.effective == 1 && !scope.row.overdue" auth="point:mall:update">
          <el-button type="text" class="error" @click="updateStatus(scope.row, 0)">下架</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import { api_getPointmallPage, api_putPointMallEffective} from '@/api/scoreShop'
import tableList from '@/mixins/tableList'
export default {
  name: "mPortrait",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "商品类型",
          placeholder: "请选择商品类型",
          type: "select",
          multiple: false,
          key: "productType",
          option: [{
            label: '优惠券',
            value: 'Coupon'
          },{
            label: '礼品券',
            value: 'GiftCoupon'
          },{
            label: '停车券',
            value: 'LotCoupon'
          },
          {
            label: '其他',
            value: 'Commodity'
          }],
        },
        {
          label: "上架状态",
          placeholder: "请选择上架状态",
          type: "select",
          multiple: false,
          key: "effective",
          option: [{
            label: '上架',
            value: 1
          },{
            label: '下架',
            value: 0
          }],
        },
        {
          label: "售卖时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "salesTime",
        },
        {
          label: "售卖状态",
          placeholder: "请选择售卖状态",
          type: "select",
          multiple: false,
          key: "soldOut",
          option: [{
            label: '未售罄',
            value: '0'
          },{
            label: '已售罄',
            value: '1'
          }],
        },
      ],
      form: {
      },
      tableThData: [
        { prop: "productType", label: "商品类型", minWidth: "120", },
        { prop: "name", label: "商品名称", minWidth: "260", },
        { prop: "picture", label:"商品图片", minWidth: "130", },
        { prop: "quantity", label: "上架数量", minWidth: "100", },
        { prop: "remainingQuantity", label: "剩余数量", minWidth: "100", },
        { prop: "point", label: "售价", minWidth: "150", },
        { prop: "created", label: "创建时间", minWidth: "160", },
        { prop: "salesTime", label: "售卖时间", minWidth: "320", },
        { prop: "effective", label: "上架状态", minWidth: "100", },
        { prop: "soldOut", label: "售罄状态", minWidth: "100", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "120", },
      ],
    };
  },
  created () {
  },
  methods: {
    onAdd () {
      this.$router.push({
        path: '/scoreShop/index/add'
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.salesTime && newParams.salesTime.length > 0){
        newParams.salesEndTime = +new Date(newParams.salesTime[0])
        newParams.salesEndTime = +new Date(newParams.salesTime[1])
      }
      delete newParams.salesTime
      const data = await api_getPointmallPage(newParams)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 编辑
    edit (row) {
      this.$router.push({
        path: '/scoreShop/index/add?id=' + row.id
      })
    },
    // 删除
    updateStatus (row, status) {
      this.$baseConfirm(
        status == 1 ? '是否确认上架该商品？' : '是否确认下架该商品？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_putPointMallEffective({id: row.id, effective: status})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.rule {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  .image{
    width: 80px;
    height: 80px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
